exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".voucher-price {\n  position: relative;\n}\n.voucher-price .remove {\n  position: absolute;\n  top: 0;\n  right: -2em;\n}\n.voucher-price .remove i {\n  font-size: 1em;\n}", ""]);

// exports
